import styled from "styled-components";
import { Text, Image, Box } from "@vinomofo/components";
import { FONT_FAMILIES } from "../../styles";

const { dmSans } = FONT_FAMILIES;

const LogoCollectionContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  margin: 0 auto;
  position: relative;
  z-index: 109;

  @media ${({ theme }) => theme.mq.max.mobile} {
    margin: -100px auto 0px;
    padding: 20px 10px 20px;
  }
`;

const StyledText = styled(Text)`
  font-family: ${dmSans};
  font-size: 30px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 2%;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 20px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 20px;
    padding-top: 60px;
    max-width: 25rem;
  }
`;

const LogoImage = styled(Image)`
  max-width: 100%;
  height: auto;

  mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 15%,
    black 85%,
    transparent 100%
  );

  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 15%,
    black 85%,
    transparent 100%
  );
`;

interface LogoCollectionProps {
  heading: string;
  logoImageUrl: string;
  logoAltText?: string;
}

export const LogoCollection = ({
  heading,
  logoImageUrl,
  logoAltText = "Brand logos collection",
}: LogoCollectionProps) => {
  return (
    <LogoCollectionContainer>
      {/* <StyledText>{heading}</StyledText> */}
      <LogoImage src={logoImageUrl} alt={logoAltText} />
    </LogoCollectionContainer>
  );
};
